import { Pipe, PipeTransform } from '@angular/core';
import { LicenceStatus } from '../../viewmodels/licence';

@Pipe({
  name: 'licenceStatus',
})
export class LicenceStatusPipe implements PipeTransform {

  transform(value: LicenceStatus, args?: any): any {
    return LicenceStatus[value];
  }

}
